/** Helpers for custom-invoice trip details (multi-trip + timed stops).
 *
 * trip_details on an invoice may be:
 *  - null
 *  - a single trip object (legacy)
 *  - an array of trip objects (multi-trip, Mar 2026)
 * Each trip's stops may be plain strings (legacy) or {address, time} objects.
 */

export function normalizeTripDetails(raw) {
  const tds = Array.isArray(raw) ? raw : (raw ? [raw] : []);
  return tds.map(td => ({
    ...td,
    stops: (td.stops || []).map(s =>
      typeof s === "string" ? { address: s, time: null } : (s || { address: "", time: null })
    ),
  }));
}

/** "17:45" -> "5:45 PM"; passthrough for anything else. */
export function fmtStopTime(t) {
  if (!t) return "";
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(t).trim());
  if (!m) return t;
  let h = parseInt(m[1], 10);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m[2]} ${ampm}`;
}

/** "2026-07-31" -> "Jul 31, 2026"; passthrough otherwise. */
export function fmtBookedOn(d) {
  if (!d) return "";
  try {
    const [y, m, day] = String(d).split("-").map(Number);
    if (!y || !m || !day) return d;
    return new Date(y, m - 1, day).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return d; }
}
